import { useQuery } from '@tanstack/react-query';
import { getBrowserClient } from '@/lib/supabase';
import { useHostessStore } from '@/stores/hostess';
import { useAssignedStores } from '@/hooks/useAssignedStores';

export type TabCounts = Record<string, number>;

export function useTabCounts() {
  const { hostess } = useHostessStore();
  const hostessId = hostess?.id;
  const { data: assignedStores } = useAssignedStores();
  const storeIds = assignedStores?.map(s => s.id);

  return useQuery<TabCounts>({
    queryKey: ['tab-counts', hostessId, storeIds],
    queryFn: async () => {
      const supabase = getBrowserClient();
      const { data, error } = await supabase.rpc('get_dashboard_tab_counts', {
        p_hostess_id: hostessId!,
        p_store_ids: storeIds!,
      });

      if (error) throw new Error(`タブ件数取得エラー: ${error.message}`);

      const counts: TabCounts = {};
      for (const row of data || []) {
        counts[row.tab] = row.count;
      }
      return counts;
    },
    enabled: !!hostessId && !!storeIds && storeIds.length > 0,
    staleTime: 30 * 1000, // 30秒キャッシュ
  });
}
